/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    PARALLAX
\*------------------------------------*/
class Parallax {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var div = self.elem;

        self.scroll(div);
    }

    scroll(e) {
        let self = this;

        var el = e;
        var imgs = e.getElementsByClassName('materials-img__image');
        var img = imgs[0];

        document.addEventListener('scroll', function(e) {
            self.checkViewport(el, img);
        });
    }

    checkViewport(e, img) {
        var bounding = e.getBoundingClientRect();
        var maths = bounding.top/15+110;

        img.style.bottom = maths+'px';
    }
}

export default Parallax;
